import React from 'react';
import { TitledList } from './CommonTypes';

export type ListProps = {
  id: string;
  list: TitledList;
};

export const List = ({ id, list }: ListProps): JSX.Element => {
  return (
    <>
      <p className='p1-bold m05-bottom cms'>{list.title}</p>
      {list.items.map((item, i) => (
        <p key={`${id}-${i}`} className='p3 m15-bottom cms'>
          {item.icon && (
            <img
              className='icon-style m1-right'
              src={item.icon}
              alt={`icon-${i}`}
            />
          )}
          <span>{item.text}</span>
        </p>
      ))}
    </>
  );
};

export default List;
